import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaTwitter, FaMapMarkerAlt, FaReact } from 'react-icons/fa';
import './Contact.css';
import { SiSpringboot } from 'react-icons/si';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Aquí conectarías con tu backend
    setFormStatus('sending');
    
    setTimeout(() => {
      setFormStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      setTimeout(() => {
        setFormStatus('');
      }, 3000);
    }, 1500);
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      label: 'Email',
      value: 'edsonda1405@gmail.com',
      link: 'mailto:edsonda1405@gmail.com'
    },
    {
      icon: <FaMapMarkerAlt />,
      label: 'Location',
      value: 'Mexico',
      link: null
    },
    {
      icon: <FaLinkedin />,
      label: 'LinkedIn',
      value: 'Edson Alvarado',
      link: 'https://www.linkedin.com/in/edson-alvarado-dev'
    }
  ];

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <motion.h2 
          className="section-title gradient-text"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
         Contact Me 
        </motion.h2>

        <motion.p 
          className="contact-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Do you have a project in mind? Let’s talk.
        </motion.p>

        <div className="contact-content">
          {/*}
          <motion.div 
            className="contact-form-container"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What would you like to talk about?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Tell me about your project..."
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="btn-submit"
                disabled={formStatus === 'sending'}
              >
                {formStatus === 'sending' ? 'Sending...' : 
                formStatus === 'success' ? '✓ Sent' : 
                'Send Message'}
              </button>

              {formStatus === 'success' && (
                <motion.div 
                  className="success-message"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  Message sent successfully! I’ll get back to you soon.
                </motion.div>
              )}
            </form>
          </motion.div>
          */}

          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="info-card">
              <h3>Contact Information</h3>
              <p>Feel free to reach out through any channel. I am available for new opportunities and collaborations.</p>

              <div className="contact-details">
                {contactInfo.map((info, idx) => (
                  <motion.div 
                    key={idx}
                    className="contact-item"
                    whileHover={{ x: 5 }}
                  >
                    {info.link ? (
                      <a href={info.link} target="_blank" rel="noopener noreferrer">
                        <span className="contact-icon">{info.icon}</span>
                        <div className="contact-text">
                          <span className="contact-label">{info.label}</span>
                          <span className="contact-value">{info.value}</span>
                        </div>
                      </a>
                    ) : (
                      <>
                        <span className="contact-icon">{info.icon}</span>
                        <div className="contact-text">
                          <span className="contact-label">{info.label}</span>
                          <span className="contact-value">{info.value}</span>
                        </div>
                      </>
                    )}
                  </motion.div>
                ))}
              </div>
            </div>

            {/*
            <div className="social-links">
              <h4>Sígueme en redes</h4>
              <div className="social-icons">
                <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                  <FaGithub />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="mailto:tu@email.com">
                  <FaEnvelope />
                </a>
              </div>
            </div>
             */}
          </motion.div>
        </div>
      </div>

      <footer className="footer">
  <p>
    &copy; 2026 Edson Alvarado. Developed with{" "}
    <FaReact style={{ color: "#61DAFB", verticalAlign: "middle" }} /> React {" "}
    { /* <SiSpringboot style={{ color: "#6DB33F", verticalAlign: "middle" }} /> Spring Boot */}
  </p>
</footer>

    </section>
  );
};

export default Contact;
